<template>
  <el-popover
    v-model="popover"
    popper-class="diy-popover"
    class="scrollbar-y"
    :placement="placement"
    :width="popoverWidth"
    :trigger="trigger">
    <el-tabs v-if="activeName" v-model="activeName" stretch>
      <el-tab-pane v-for="item in tabs" :key="item.name" :label="item.label" :name="item.name">
        <!--   空div是为了解决activeName显示bug     -->
        <div></div>
      </el-tab-pane>
    </el-tabs>
    <el-input
      ref="filterText"
      size="mini"
      v-model="filterText"
      placeholder="请输入名称搜索"
      class="mb-10">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <el-scrollbar style="height: 300px">
      <el-tree
        :data="treeData"
        node-key="id"
        ref="tree"
        empty-text="暂无匹配数据"
        @node-click="nodeClick"
        @check-change="checkChange"
        :filter-node-method="filterNode"
        accordion
        :show-checkbox="multiple">
        <span class="display-flex ai-center jc-space-between flex-1" slot-scope="{ node }">
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </el-scrollbar>
    <el-input
      slot="reference"
      ref="input"
      @clear="clearInput"
      clearable
      class="width-percent-100"
      :size="inputSize"
      :disabled="isDisabled"
      :style="{width: inputWidth}"
      v-model="selectedName"
      :placeholder="placeholder">
    </el-input>
  </el-popover>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'PersonnelSelection',
  components: {},
  props: {
    tabs: {
      type: Array,
      default () {
        return []
      }
    }, // 选人类型
    interfaceUrl: {
      type: String,
      default () {
        return '/sys/user/tree'
      }
    }, // 出现位置
    tenantId: {
      type: String,
      default () {
        return ''
      }
    },
    defaultCheckedKeys: {
      type: Array,
      default () {
        return []
      }
    }, // 默认选中
    placement: {
      type: String,
      default () {
        return 'bottom'
      }
    }, // 出现位置
    trigger: {
      type: String,
      default () {
        return 'click'
      }
    }, // 显示方式
    popoverWidth: {
      type: String,
      default () {
        return '400'
      }
    }, // 弹出宽度
    inputWidth: {
      type: String,
      default () {
        return '200px'
      }
    }, // 输入框宽度
    inputSize: {
      type: String,
      default () {
        return ''
      }
    }, // 输入框size
    placeholder: {
      type: String,
      default () {
        return '请选择人员'
      }
    },
    multiple: {
      type: Boolean,
      default () {
        return true
      }
    },
    isDisabled: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      activeName: '',
      popover: false,
      treeData: [], // 树结构数据
      filterText: '', // 选人组件内名称搜索
      selectedName: '', // 选中的人名
      checkedNodes: []// 已选择的
    }
  },
  filters: {},
  computed: {
  },
  watch: {
    activeName (newVal, oldVal) {
      this.$emit('change', [], [], oldVal)
      this.$refs.tree.setCheckedKeys([])
      this.$refs.filterText.focus()
    },
    popover (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.filterText.focus()
        })
      }
    },
    filterText (val) {
      this.$refs.tree.filter(val);
    },
    defaultCheckedKeys (val) {
      if (val[0]) {
        if (!val[0].length) {
          this.$refs.tree.setCheckedKeys([])
        }
      }
    }
  },
  methods: {
    /**
     * 树结构筛选方法，与watch方法需要共用
     */
    filterNode (value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /**
     * 节点被点击时的回调
     * @param data - 传递给 data 属性的数组中该节点所对应的对象
     */
    nodeClick (data) {
      if (data.type === 1) {
        // 筛选出已经选中的子节点的id集合
        const treeCheckedNodeIds = [...new Set(this.$refs.tree.getCheckedNodes().filter(_item => _item.type === 1).map(item => item.id))]
        // 获取当前节点的选中状态
        if (!treeCheckedNodeIds.includes(data.id)) {
          if (this.multiple) {
            // 多选
            this.$refs.tree.setCheckedKeys([data.id, ...treeCheckedNodeIds])
          } else {
            // 单选
            this.$refs.tree.setCheckedKeys([data.id])
          }
        } else {
          if (this.multiple) {
            // 多选
            this.$refs.tree.setCheckedKeys([...treeCheckedNodeIds.filter(item => item !== data.id)])
          } else {
            // 单选
            this.$refs.tree.setCheckedKeys([])
          }
        }
      }
    },
    /**
     * 节点选中状态发生变化时的回调
     * @param data - 传递给 data 属性的数组中该节点所对应的对象
     * @param state - 节点本身是否被选中
     */
    checkChange (data, state) {
      if (this.multiple) {
        this.checkedNodes = this.$refs.tree.getCheckedNodes().filter(_item => _item.type === 1).reduce((prev, element) => {
          if (!prev.find(el => { return el.id === element.id && el.label === element.label })) {
            prev.push(element)
          }
          return prev
        }, [])
      } else {
        this.popover = false
        this.checkedNodes = this.$refs.tree.getCheckedNodes().filter(_item => _item.type === 1)
      }
      this.selectedName = this.checkedNodes.map(item => item.label).join('、')
      this.$emit('change', this.checkedNodes, this.checkedNodes.map(item => item.id), this.activeName)
    },
    /**
     * id，pid结构转树形结构
     * @param data 原始数据
     * @param pid 起始id
     * @returns {[]}
     */
    convertToTreeData (data, pid) {
      const result = []
      let temp = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].pid === pid) {
          const obj = {
            label: data[i].name,
            id: data[i].id,
            workload: data[i].workload,
            disabled: data[i].type !== 1 && !this.multiple,
            type: data[i].type
          }
          temp = this.convertToTreeData(data, data[i].id)
          if (temp.length > 0) {
            obj.children = temp
          }
          result.push(obj)
        }
      }
      return result
    },
    /**
     * 清空已选数据
     */
    clearInput () {
      this.$refs.tree.setCheckedKeys([])
    },
    /**
     * 获取所有人员数据
     */
    getTreeData () {
      const axios = Axios.create({
        timeout: 3000,
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: this.$store.state.token
        }
      });
      axios.get(`${this.interfaceUrl}?tenantId=${this.tenantId}`).then(res => {
        res = res.data.data
        this.treeData = this.convertToTreeData(res, '0')
        this.$nextTick(() => {
          if (this.defaultCheckedKeys.length) {
            this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys)
          }
        })
      })
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    if (this.tabs.length) {
      this.activeName = this.tabs[0].name
    }
    this.$nextTick(() => {
      this.$refs.input.$el.firstElementChild.setAttribute('readonly', 'readonly')
    })
    this.getTreeData()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>

</style>
